"use client";
import styles from './Navbar.module.scss';
import logo from '../../../../public/Brand-logo.svg';
import classNames from 'classnames';
import Image from 'next/image';
import { useState, useEffect } from 'react';
import { usePathname } from "next/navigation";
import Link from 'next/link';
import Cookies from 'js-cookie';
import { RootState } from '../../../redux/reducers/index';
import Login from '../Login/Login';
// import Profile from '../Profile/Profile';
import {CheckOutlined,InfoCircleOutlined } from '@ant-design/icons';
// import RecommendationFlow from '../../recommendations/RecommendationFlow/RecommendationFlow';

import { resetAfterMessage } from '../../../redux/reducers/commonReducer';
import {scrollToSection} from '../../../utils/common';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import {decodeToken,DecodedToken} from '@/utils/jwtDecode';

import NotificationDropdown from '@/components/common/NotificationDropdown/NotificationDropdown';


const Navbar = () => {

  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);
  const [isSignup, setIsSignup] = useState<boolean>(false);
  const pathname = usePathname();
  const [token, setToken] = useState<string | null>(null);
  const [Decodetoken, setDecodeToken] = useState<DecodedToken | null>(null);
  const { profile, toggle } = useSelector((state: RootState) => state.profile);
  const { afterMessage } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        scrollToSection('pageTop');
    }, [toggle])

  
    useEffect(() => {
      if (afterMessage.isDsiplay) {
        const timer = setTimeout(() => {
          dispatch(resetAfterMessage());
        }, 3000);
        return () => clearTimeout(timer); 
      }
    }, [afterMessage.isDsiplay, dispatch]);

  useEffect(() => {
    const jwtToken = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
    if(jwtToken){
      const decodedToken = decodeToken(jwtToken); 
      setDecodeToken(decodedToken);
    }

    setToken(jwtToken || null);
  }, []);

  const openLoginModal = (isSignup: boolean) => {
    setIsSignup(isSignup);
    setIsLoginModalVisible(true);
  };

  const closeLoginModal = () => {
    setIsSignup(isSignup);
    setIsLoginModalVisible(false);
  };

  if (
    pathname.startsWith("/registration") || 
    pathname.startsWith("/pricing") || 
    pathname.startsWith("/mobile-responsive")) {
  return null;
}

  return (
    <>
    <nav  id="pageTop" className={classNames(styles.navbar, 'primary_font')}>

      <div className={classNames(styles.logo, 'flex', pathname.startsWith("/testimonial") ? 'margin-left-alt' : 'margin-left')}>
      {
        token ? (
          <Link href={`/cr/${Decodetoken?.slug}`}><Image src={logo} alt="menu" priority /></Link>
        ) : (
          <Link href='/'><Image src={logo} alt="menu" priority /></Link>
        )
      }
       
      </div>

      <ul className={classNames(styles.navlinks, 'flex', pathname.startsWith("/testimonial") ? 'margin-right-alt' : 'margin-right')}>

      {
        token && (
          <li className={classNames(styles.navlinks, 'secondary_text_color')}> < NotificationDropdown/></li> 
        )
      }
    

        <div className={classNames(styles.navButtons, 'primary_font')}>

          {token ? (
            <>
              <li>
                {/* <Profile /> */}
              </li>
             
            </>

          ) : (
            <>
              {

            (pathname == "/" ||( profile && profile.view==='public') ) && (
            <li>
            <button
              className={classNames(styles.btnLogin,'secondary-btn-color')}
              onClick={() => openLoginModal(false)}
            >
             Sign In
            </button>
          </li>
            )
          }
              {/* <li className={styles.navItemHide}>
                <button
                  className={classNames(styles.btnLogin, 'primary_text_color')}
                  onClick={() => openLoginModal(true)}
                >
                  Sign up
                </button>
              </li> */}
            </> 
          )}


          {/* {
           profile && profile.view==='public' && !token && pathname != "/" && (
            <li
           //  className={styles.navItemHide}
           >
            <button
              className={classNames(styles.btnCreate, 'primary_text_color')}
              onClick={() => openLoginModal(true)}
            >
              Create an account
            </button>
          </li>
            )
          } */}

          {/* <li className={styles.navItemHide}>
            <button
              className={classNames(styles.btnRecommend, 'primary_text_color', 'primary-btn-color')}
              onClick={() => openRecommendationModal()}
            >
              Recommend <Image src={rec} alt='' />
            </button>
          </li> */}

          {/* {
           profile && profile.view==='public' && pathname != "/" && (
              <li className={classNames('not-visible')}>
                <RecommendationFlow />
              </li>
            )
          } */}

        </div>

      </ul>

      {isLoginModalVisible && (
        <Login visible={isLoginModalVisible} onClose={closeLoginModal} isSignUp={isSignup} setIsSignup={setIsSignup} />
      )}
    </nav>
    {
  afterMessage.isDsiplay ? (
    afterMessage.type === "success" ? (
      <div className={classNames('sucessBanner', 'primary_font')}>
        <CheckOutlined style={{ color: "white" }} />
        {afterMessage.message}
      </div>
    ) :  (
      <div className={classNames('errorBanner', 'primary_font')}>
        <InfoCircleOutlined style={{ color: "white" }} />
        {afterMessage.message}
      </div>
    ) 
  ) : (
    <div className={styles.navBottomSpace}></div>
  )
}

    </>
  );
};

export default Navbar;